import { motion } from "framer-motion";
import { Instagram, Heart } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { ASSETS, BRAND } from "@/lib/constants";

const POSTS = [
  "/insta/fam-sofa.jpg",
  "/insta/hand-chip.jpg",
  "/insta/couple-laugh.jpg",
  ASSETS.palakPiri,
  "/insta/pour-bowl.jpg",
  "/insta/friends-movie.jpg",
  "/insta/mom-kid.jpg",
  ASSETS.moringaTango,
];

export default function InstagramSection() {
  return (
    <section className="bg-black py-24 lg:py-28" data-testid="instagram-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <div className="flex flex-col items-center text-center">
            <Overline>@dignityfoodkitchen</Overline>
            <h2 className="mt-3 font-display text-5xl leading-none tracking-tight text-cream sm:text-7xl">
              FOLLOW THE <span className="text-gold-gradient">CRUNCH</span>
            </h2>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 gap-3 sm:grid-cols-4">
          {POSTS.map((src, i) => (
            <motion.a key={i} href={BRAND.social.instagram} target="_blank" rel="noreferrer"
              initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }} transition={{ delay: (i % 4) * 0.06 }}
              className="group relative aspect-square overflow-hidden rounded-2xl"
              data-testid={`insta-post-${i}`}>
              <img src={src} alt={`Dignity Food Kitchen lifestyle snacking moment ${i + 1}`} loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 flex items-center justify-center bg-black/50 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <div className="flex items-center gap-2 text-cream">
                  <Instagram size={20} /> <Heart size={18} className="fill-red-500 text-red-500" />
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
